import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getNewProduct } from '../../../../api/product/queries/getNewProduct';
import { INewProduct } from '../../../../interfaces/Product.interfaces';

export const useGetNewProductQuery = () => {
  return useQuery<INewProduct, AxiosError>(['new-product'], () =>
    getNewProduct({ searchParam: { category: 'PLUVA,PARTNER' } }),
  );
};
